<template>
  <el-main
      v-if="pdfUrl !== ''"
      v-loading="pdfLoading"
      style="padding: 0"
      class="pdf-container"
      :element-loading-text="'加载中...' + (loadedRatio * 100).toFixed(2).replace(/\.?0+$/, '') + '%'"
      element-loading-spinner="el-icon-loading">
    <div class="controls">
      <el-button type="primary" :disabled="totalPages > 0 && currentPage <= 1" @click="prevPage">上一页</el-button>
      <span style="align-content: center">第 {{currentPage}}/{{totalPages}} 页</span>
      <el-button type="primary" :disabled="totalPages > 0 && currentPage >= totalPages" @click="nextPage">下一页</el-button>
      <el-button @click="downloadPDF">下载PDF</el-button>
    </div>
    <div style="overflow-y: auto">
      <pdf
          ref="pdf"
          style="height: 800px"
          :src="pdfUrl"
          :page="currentPage"
          @progress="loadedRatio = $event; pdfLoading = true"
          @page-loaded="pageLoaded($event); pdfLoading = false"
          @error="pdfError($event)"
          @num-pages="totalPages = $event"/>
    </div>
  </el-main>
</template>

<script>
  import pdf from "vue-pdf";

  export default {
    name: "PdfViewer",
    components: { pdf },
    props: {
      pdfUrl: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        pdfLoading: false,
        downloadLoading: false,
        dialogVisible: false,
        pdfUrlCopy: "",
        currentPage: 1,
        totalPages: 0,
        // 加载进度
        loadedRatio: 0,
        // 放大系数 默认百分百
      };
    },
    watch: {
      pdfUrl(val) {
        if (this.pdfUrlCopy !== this.pdfUrl) {
          this.currentPage = 1;
        }
        this.pdfUrlCopy = val;
      },
    },
    methods: {
      pageLoaded(e) {
        this.$emit("current", e);
      },
      pdfError(error) {
        console.error(error);
      },
      // 页面切换
      prevPage() {
        this.currentPage = Math.max(1, this.currentPage - 1);
      },
      nextPage() {
        this.currentPage = Math.min(this.totalPages, this.currentPage + 1);
      },
      downloadPDF() {
        window.open(this.pdfUrl);
      },
    },
  };
</script>
<style scoped>

.controls {
    display: flex;
    gap: 10px;
    justify-content: center;
}
</style>
